import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { GridResizeEvent } from './grid-resize.model';

export type GridResizeEventName = 'ColumnSizesChanged' | 'FillingColumnTouched' | 'HeaderResizerTouched' |'HeaderResizing' | 'HeaderResizied';

interface GridResizerEvent<TData> extends GridResizeEvent<TData> {
    name: GridResizeEventName;
    value: TData;
    viewport: Element;
}

@Injectable({providedIn: 'root'})
export class GridResizeService {
    private message$ = new Subject<GridResizerEvent<any>>();

    public constructor() { }

    public emit<TData>(event: GridResizerEvent<TData>) {
        this.message$.next(event);
    }

    public on<TData>(eventName: GridResizeEventName, viewport: Element, action: (event: TData) => void): Subscription {
        return (this.message$ as Subject<GridResizerEvent<TData>>).pipe(
            filter((event: GridResizerEvent<TData>) => (event.name === eventName) && (viewport === event.viewport)),
            map((event: GridResizerEvent<TData>) => event.value)
        ).subscribe(action);
    }
}
